import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from "react-router-dom";
import { logout } from "../features/user";
import axios from "axios";
import { API_URL, API_OK, API_EXCEPTION, DEFAULT_ERROR_TEXT } from '../Constants';
import '../styles.css';
import cookie from "js-cookie";
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { showErrorDialog } from "../features/errorDialog";
import {handleApiErrorMessage} from "../Helper";

export default function Device(props) {
  const { t } = useTranslation();

  const initialLineDeviceValue = {
    imei: null,
    model: null,
    brand: null,
    canUnblock: false
  };
  const [lineDevice, setLineDevice] = useState(initialLineDeviceValue);
  const [loading, setLoading] = useState(false);
  const [unblocking, setUnblocking] = useState(false);
  const [unblocked, setUnblocked] = useState(false);
  const [showUnblockToast, setShowUnblockToast] = useState(false);

  const communityAllowsUnblock = localStorage.getItem('allow_unblock_line_from_invalid_imei') === "true";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if(loading){
      return () => {};
    }
    refreshDeviceData();
  }, [props.line.id]);

  const refreshDeviceData = () => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);
    setLoading(true);

    let  headers = {
      token: cookie.get('token')
    }

    axios.post(API_URL + '/getLineDevice', {customer_id: props.customer.id, line_id: props.line.id}, {headers})
    .then(
      ({ data }) => {
        if(data.hasOwnProperty("responseStatus") && (data["responseStatus"] === API_OK && data.hasOwnProperty("lines"))){
          setLineDevice(data.lines);
          setLoading(false);
        }else{
          if((data.responseStatus === API_EXCEPTION) && (data.hasOwnProperty("message"))){
            errorMessage = data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setLoading(false);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setLoading(false);
    });
  };

  const handleUnblockImei = () => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);
    setUnblocking(true);
    const headers = { token: cookie.get('token') };
    axios.post(API_URL + '/unblockLineFromInvalidImei', { customer_id: props.customer.id, line_id: props.line.id }, { headers })
      .then(({ data }) => {
        if(data.hasOwnProperty("responseStatus") && data["responseStatus"] === API_OK){
          setUnblocked(true);
          setLineDevice((prev) => ({ ...prev, canUnblock: false }));
          setUnblocking(false);
          setShowUnblockToast(true);
          setTimeout(() => setShowUnblockToast(false), 2200);
        }else{
          if((data.responseStatus === API_EXCEPTION) && (data.hasOwnProperty("message"))){
            errorMessage = data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setUnblocking(false);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setUnblocking(false);
    });
  };

  const render = (lineDevice) => {
    return(
    <div className='dev-card'>
      <div className='dev-card-head'>
        <div className='dev-card-icon'>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2.5"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
        </div>
        <div className='dev-card-titles'>
          <div className='dev-card-title'>פרטי המכשיר</div>
          <div className='dev-card-sub'>{[lineDevice.brand, lineDevice.model].filter(Boolean).join(' · ') || '—'}</div>
        </div>
        {renderUnblock()}
      </div>
      <div className='dev-rows'>
        <div className='dev-row'>
          <span className='dev-row-label'>{"IMEI"}</span>
          <span className='dev-row-val' dir="ltr">{lineDevice.imei || '—'}</span>
        </div>
        <div className='dev-row'>
          <span className='dev-row-label'>{t('Device Brand')}</span>
          <span className='dev-row-val'>{lineDevice.brand || '—'}</span>
        </div>
        <div className='dev-row'>
          <span className='dev-row-label'>{t('Device Model')}</span>
          <span className='dev-row-val'>{lineDevice.model || '—'}</span>
        </div>
      </div>
    </div>);
  }

  const renderUnblock = () => {
    if (!communityAllowsUnblock) return null;
    if (unblocked) {
      return null;
    }
    if (!lineDevice.canUnblock) return null;
    return (
      <div className='dev-unblock-bar'>
        <div className='dev-unblock-msg'>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          <span>שימו לב, ה-IMEI של מכשיר זה חסום.</span>
        </div>
        <button className='dev-unblock' onClick={handleUnblockImei} disabled={unblocking}>
          {unblocking ? (
            <span className='dev-unblock-spinner' />
          ) : (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/></svg>
          )}
          {unblocking ? 'משחרר...' : 'שחרר חסימת IMEI'}
        </button>
      </div>
    );
  };

return <div className='device-wrapper'>
    {loading ? (
      <div className='dev-loading'>
        <div className='dev-loading-text'>
          <span className='dev-loading-spinner' />
          טוען פרטי מכשיר...
        </div>
        <div className='dev-loading-bar'><span /></div>
      </div>
    ) : lineDevice.imei !== null ?
      (props.hasOwnProperty("render") ?
        props.render(lineDevice) :
        render(lineDevice)
      )
      : ''}
    {showUnblockToast && createPortal(
      <div className="cat-toast-overlay">
        <div className="cat-toast">
          <div className="cat-toast-check">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <div className="cat-toast-text">ה-IMEI שוחרר בהצלחה</div>
        </div>
      </div>,
      document.body
    )}
  </div>
}
